import { Icon, Tooltip, TooltipContent, TooltipTrigger } from '@repo/ui'
import { Warning } from '@repo/ui/icons'

/** Warns that a displayed amount is a JS-math estimate because the EVM simulation couldn't verify it. */
export const SimulationEstimateBadge = () => (
  <Tooltip>
    <TooltipTrigger asChild>
      <div className="flex items-center" tabIndex={0} role="img" aria-label="Estimated amount">
        <Icon className="text-warning-foreground" icon={<Warning />} />
      </div>
    </TooltipTrigger>
    <TooltipContent>
      The transaction couldn’t be simulated. The displayed amounts may differ from the final
      execution.
    </TooltipContent>
  </Tooltip>
)
